import { Navigate, Outlet, useLocation } from "react-router";

import { useUser } from "@/client/services/user";

interface AuthGuardProps {
  allowAnonymous?: boolean;
}

export const AuthGuard = ({ allowAnonymous = false }: AuthGuardProps) => {
  const location = useLocation();
  const redirectTo = location.pathname + location.search;

  const { user, loading } = useUser();

  if (loading) return null;

  if (!user) {
    return <Navigate replace to={`/auth/login?redirect=${redirectTo}`} />;
  }

  if (user.isAnonymous && !allowAnonymous) {
    return <Navigate replace to="/" />;
  }

  return <Outlet />;
};
